import { type RouteObject } from 'react-router-dom';

// ── Pages publiques ───────────────────────────────────────────
import HomePage          from '@/pages/home/page';
import NotFound          from '@/pages/NotFound';
import MobileMoney       from '@/pages/mobile-money/page';
import OfflineFeatures   from '@/pages/offline-features/page';
import GuestCheckout     from '@/pages/guest-checkout/page';
import TrackingPage      from '@/pages/tracking/page';

// ── Auth ──────────────────────────────────────────────────────
import RegisterPage      from '@/pages/auth/register/page';
import LoginPage         from '@/pages/auth/login/page';
import JoinPage          from '@/pages/auth/join/page';        // rejoindre via token

// ── Dashboards individuels ────────────────────────────────────
import ClientDashboard               from '@/pages/dashboards/client-dashboard/page';
import LivreurDashboard              from '@/pages/dashboards/livreur-dashboard/page';
import LivreurProDashboard           from '@/pages/dashboards/livreur-pro-dashboard/page';

// ── Dashboard unifié entités (CompanyProfile) ─────────────────
import EntityDashboard from '@/pages/dashboards/entity-dashboard/page';
import { ENTITY_CONFIGS } from '@/domains/company/constants/entity.config';

// ── Dashboards globaux ────────────────────────────────────────
import AdminDashboard      from '@/pages/dashboards/admin-dashboard/page';
// Dashboard générique company (redirection intermédiaire)
import CompanyDashboard    from '@/pages/auth/company-dashboard/page';

import ProtectedRoute from '@/components/ProtectedRoute';
import PublicRoute from '@/components/PublicRoute';

// ══════════════════════════════════════════════════════════════
//  Routes
// ══════════════════════════════════════════════════════════════
const routes: RouteObject[] = [

  // ── Pages publiques ────────────────────────────────────────
  { path: '/',                 element: <HomePage /> },
  { path: '/mobile-money',     element: <MobileMoney /> },
  { path: '/offline-features', element: <OfflineFeatures /> },
  { path: '/guest-checkout',   element: <GuestCheckout /> },
  { path: '/tracking',         element: <TrackingPage /> },

  // ── AUTH (Protégé: non-connecté seulement) ────────────────
  //  Un utilisateur connecté sera redirigé vers son dashboard
  {
    element: <PublicRoute />,
    children: [
      { path: '/register/:userType', element: <RegisterPage /> },
      { path: '/login',              element: <LoginPage /> },
      { path: '/join/:token',        element: <JoinPage /> },
    ],
  },

  // ── DASHBOARDS PROTÉGÉS ────────────────────────────────────
  //
  //  Les allowedRoles correspondent aux types.code de Laravel.
  //  Un utilisateur 'company' qui se connecte est redirigé vers
  //  /dashboard/company d'abord, puis CompanyDashboard le
  //  redirige vers le bon dashboard selon user.entity_type.
  //
  {
    element: <ProtectedRoute />,        // connecté seulement
    children: [

      // ── Individus ─────────────────────────────────────────
      {
        element: <ProtectedRoute allowedRoles={['client']} />,
        children: [
          { path: '/dashboard/client', element: <ClientDashboard /> },
        ],
      },
      {
        element: <ProtectedRoute allowedRoles={['community_delivery']} />,
        children: [
          { path: '/dashboard/livreur', element: <LivreurDashboard /> },
        ],
      },
      {
        element: <ProtectedRoute allowedRoles={['professional_delivery']} />,
        children: [
          { path: '/dashboard/livreur-pro', element: <LivreurProDashboard /> },
        ],
      },

      // ── Entités company (accès commun) ────────────────────
      // CompanyDashboard redirige selon user.entity_type
      {
        element: <ProtectedRoute allowedRoles={['company']} />,
        children: [
          { path: '/dashboard/company', element: <CompanyDashboard /> },
        ],
      },

      // ── Dashboards entités (config-driven via CompanyProfile) ─
      {
        element: <ProtectedRoute allowedRoles={['company']} />,
        children: Object.values(ENTITY_CONFIGS).map((cfg) => ({
          path: cfg.routePath,
          element: <EntityDashboard />,
        })),
      },

      // ── Rôles globaux ─────────────────────────────────────
      {
        element: <ProtectedRoute allowedRoles={['admin', 'super_admin']} />,
        children: [
          { path: '/dashboard/admin', element: <AdminDashboard /> },
        ],
      },
    ],
  },

  // ── 404 ───────────────────────────────────────────────────
  { path: '*', element: <NotFound /> },
];

export default routes;